import create from 'zustand';

interface State {
  symbol: string;
}

interface Actions {
  setSymbol(symbol: string): void;
}

const initialState: State = {
  symbol: '',
};

const useFastOrderForm = create<State & Actions>((set) => ({
  ...initialState,
  setSymbol: (symbol: string) => {
    set({ symbol });
  },
}));

export default useFastOrderForm;
